// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

window.__launchsignal_controllers_index_loaded = true
console.log("LaunchSignal controllers/index.js loaded")


import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import PasswordConfirmationController from "./password_confirmation_controller"
application.register("password-confirmation", PasswordConfirmationController)

import NavbarChromeController from "./navbar_chrome_controller"
application.register("navbar-chrome", NavbarChromeController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import WaitingListInterestController from "./waiting_list_interest_controller"
application.register("waiting-list-interest", WaitingListInterestController)

import WaitingListModalController from "./waiting_list_modal_controller"
application.register("waiting-list-modal", WaitingListModalController)

import LandingAnalyticsController from "./landing_analytics_controller"
application.register("landing-analytics", LandingAnalyticsController)

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)

import CharCounterController from "./char_counter_controller"
application.register("char-counter", CharCounterController)

import TokenCalculatorController from "./token_calculator_controller"
application.register("token-calculator", TokenCalculatorController)

import AppProjectStepsController from "./app_project_steps_controller"
application.register("app-project-steps", AppProjectStepsController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import AdminEmailCampaignController from "./admin_email_campaign_controller"
application.register("admin-email-campaign", AdminEmailCampaignController)

import AppAccordionController from "./app_accordion_controller"
application.register("app-accordion", AppAccordionController)

import CampaignsFilterController from "./campaigns_filter_controller"
application.register("campaigns-filter", CampaignsFilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import DropdownMenuController from "./dropdown_menu_controller"
application.register("dropdown-menu", DropdownMenuController)

import TesterProfileModalController from "./tester_profile_modal_controller"
application.register("tester-profile-modal", TesterProfileModalController)

import LanguageSelectController from "./language_select_controller"
application.register("language-select", LanguageSelectController)

import ScreenshotUploaderController from "./screenshot_uploader_controller"
application.register("screenshot-uploader", ScreenshotUploaderController)

import WaitingListController from "./waiting_list_controller"
application.register("waiting-list", WaitingListController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TestStepsController from "./test_steps_controller"
application.register("test-steps", TestStepsController)

import ReportFieldsController from "./report_fields_controller"
application.register("report-fields", ReportFieldsController)

import PaywallController from "./paywall_controller"
application.register("paywall", PaywallController)

import TokenBalanceDisplayController from "./token_balance_display_controller"
application.register("token-balance-display", TokenBalanceDisplayController)

import FormProgressController from "./form_progress_controller"
application.register("form-progress", FormProgressController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import ReportsPanelController from "./reports_panel_controller"
application.register("reports-panel", ReportsPanelController)

import ReportsPanelTriggerController from "./reports_panel_trigger_controller"
application.register("reports-panel-trigger", ReportsPanelTriggerController)

import TestReportAutosaveController from "./test_report_autosave_controller"
application.register("test-report-autosave", TestReportAutosaveController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)
